export default {
    bind(el) {
        el.style.backgroundColor = 'var(--Gray-20, #F3F5F8)';
        el.style.outline = 'none'; // 기본 포커스 outline 제거
        el.style.border = '1px solid var(--gray-40-button-stroke, #D1D6DB)'; // 기본 border 설정
        el.style.color = '#000';
        el.addEventListener('focus', () => {   // 포커스 될때
            el.style.backgroundColor = '';            
            el.style.color = '#1e1e1e';
            el.style.border = '1px solid #184FA1'; // 포커스 시 border 색상 설정
        });
        el.addEventListener('blur', () => {  // 포커스 잃을때 
            el.style.backgroundColor = 'var(--Gray-20, #F3F5F8)';   
            el.style.border = '1px solid var(--gray-40-button-stroke, #D1D6DB)'; // 포커스 해제 시 border 색상 주황색으로 설정
        });
        el.addEventListener('input', () => {  // 입력중일때 
            el.style.backgroundColor = '';
            el.style.color = '#1e1e1e';
        });
    },
    unbind(el) {
        el.removeEventListener('focus', () => {  // 포커스될 때
            el.style.backgroundColor = '';
            el.style.border = '1px solid #184FA1'; // 포커스 시 border 색상 설정
            el.style.color = '#1e1e1e';
        });
        el.removeEventListener('blur', () => {  // 포커스 잃을 때 
            el.style.backgroundColor = 'var(--Gray-20, #F3F5F8)';  
            el.style.border = '1px solid var(--gray-40-button-stroke, #D1D6DB)'; // 포커스 해제 시 border 색상 주황색으로 설정
        });
        el.removeEventListener('input', () => {  // 입력중 일 때 
            el.style.backgroundColor = '';
            el.style.color = '#1e1e1e';
        });
    },
}


// WEBPACK FOOTER //
// ./src/components/directives/focusBackground.js